export default __webpack_public_path__ + "static/media/hero.c927d657.png";